export default "__VITE_ASSET__32cbc485__"